import React from 'react';

import { SEARCH_SUBSCRIPTION_PLAN_BILLING_PERIOD } from '../../../PhotoSearchCheckout/helpers';

export const SEARCH_SUBSCRIPTION_FEATURE_UPSELL_FEATURES = {
  MEMBERS_VIEW_ENABLED: 'members_view_enabled',
  CUSTOM_TAGS_ENABLED: 'custom_tags_enabled',
  SLIDESHOW_ENABLED: 'slideshow_enabled',
  OWNED_CONTENT_FREE_JOINS_ENABLED: 'owned_content_free_joins_enabled',
  FACE_HIGHLIGHTS_ENABLED: 'face_highlights_enabled',
  WHITE_LABEL_MARKETING_PRINTS_ENABLED: 'white_label_marketing_prints_enabled',
  EXPIRATION_DISABLED: 'expiration_disabled',
  UPLOAD_LIMIT_INCREASE_ENABLED: 'upload_limit_increase_enabled',
};

export const searchSubscriptionFeatureUpsellCaptions = {
  [SEARCH_SUBSCRIPTION_FEATURE_UPSELL_FEATURES.MEMBERS_VIEW_ENABLED]: {
    title: 'Upgrade your event to see who has joined your gallery!',
    subtitle: (
      <p>
        With Waldo Plus you can see who has joined your events to find their
        photos, along with many other wonderful features — like having 200GB of
        storage, face-finding, live slideshows, and more!
      </p>
    ),
  },
  [SEARCH_SUBSCRIPTION_FEATURE_UPSELL_FEATURES.CUSTOM_TAGS_ENABLED]: {
    title: 'Upgrade your account to unlock custom tags!',
    subtitle: (
      <p>
        With Waldo Plus you can customize tags on albums and photos, and unlock
        many other wonderful features — like having 200GB of storage,
        face-finding, live slideshows, and more!
      </p>
    ),
  },
  [SEARCH_SUBSCRIPTION_FEATURE_UPSELL_FEATURES.SLIDESHOW_ENABLED]: {
    title: 'Upgrade your account to unlock live slideshows!',
    subtitle: (
      <p>
        With Waldo Plus unlock live slideshows at your events, along with many
        other wonderful features — like having a 15% discount on prints, 5x the
        storage, 2x the face finding, and more!
      </p>
    ),
  },
  [SEARCH_SUBSCRIPTION_FEATURE_UPSELL_FEATURES.OWNED_CONTENT_FREE_JOINS_ENABLED]:
    {
      illustration: '/search_subscription_matches_feature_upsell.png',
      title: (
        <>
          Upgrade and let Waldo find &
          <br />
          deliver all the photos you&apos;re in from
          <br />
          Waldo-fied events!
        </>
      ),
      subtitle: (
        <p>
          With Waldo Plus you can get face finding for up to 10 people, along
          with many other wonderful features &ndash; like having 200GB of
          storage, live slideshows, and more!
        </p>
      ),
    },
  [SEARCH_SUBSCRIPTION_FEATURE_UPSELL_FEATURES.FACE_HIGHLIGHTS_ENABLED]: {
    title: 'Upgrade your event to tag and find photos of every guest!',
    subtitle: (
      <p>
        With Waldo Plus you can customize tags on albums and photos, and unlock
        many other wonderful features &ndash; like having 100GB of dedicated
        storage, live slideshows, Video Guestbook, and more!
      </p>
    ),
  },
  [SEARCH_SUBSCRIPTION_FEATURE_UPSELL_FEATURES.WHITE_LABEL_MARKETING_PRINTS_ENABLED]:
    {
      title: 'Remove watermark and unlock more features',
    },
  [SEARCH_SUBSCRIPTION_FEATURE_UPSELL_FEATURES.EXPIRATION_DISABLED]: {
    title: <>Reactivate your events with Waldo Plus!</>,
    subtitle: (
      <p>
        With Waldo Plus, expired events are reactivated and your events never
        expire along with many other wonderful features — like having 200GB of
        storage, face-finding, live slideshows, and more!
      </p>
    ),
  },
  [SEARCH_SUBSCRIPTION_FEATURE_UPSELL_FEATURES.UPLOAD_LIMIT_INCREASE_ENABLED]: {
    title: <>Increase your storage limit with Waldo Plus!</>,
    subtitle: (
      <p>
        Unlock more space for your memories with Waldo Plus! Enjoy 200GB of
        storage to safely keep all your photos and videos, along with amazing
        features like face-finding, live slideshows, and unlimited access to
        your events — no more worrying about expiration!
      </p>
    ),
  },
};

export const sortSubscriptionsByBillingPeriod = (
  subscriptions,
  billingPeriod = SEARCH_SUBSCRIPTION_PLAN_BILLING_PERIOD.MONTHLY,
) => {
  if (!subscriptions) {
    return [];
  }

  return [...subscriptions].sort((a, b) => {
    if (billingPeriod === SEARCH_SUBSCRIPTION_PLAN_BILLING_PERIOD.YEARLY) {
      // Yearly first
      if (a.days > b.days) {
        return -1;
      }

      if (a.days < b.days) {
        return 1;
      }

      return 0;
    }

    // Monthly first
    if (a.days < b.days) {
      return -1;
    }

    if (a.days > b.days) {
      return 1;
    }

    return 0;
  });
};
